<template>
  <section class="curators">
    <header>
      <h2>Meet the Curators</h2>
    </header>
    <ul>
      <li v-for="oenologist in wineTeam" :key="oenologist.id">
        <div class="image">
          <img
            :src="oenologist.photo_image"
            :alt="`Portrait of ${oenologist.name}`"
          />
        </div>
        <div class="copy">
          <h3>{{ oenologist.name }}</h3>
          <h4>{{ oenologist.expertise }}</h4>
          <p v-html="oenologist.biography_long"></p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'CollectorsCurators',
  async setup() {
    const { data, error } = await useFetch('/api/catalog/oenologists/', {
      query: { 'collectors-club-page': true },
    })

    if (error.value) {
      console.error(error.value)
      throw error.value
    }
    const wineTeam = computed(() => data.value?.results || [])
    return {
      wineTeam,
    }
  },
}
</script>
